import { type BookmarksRecordPositionAttributes } from './generated/BookmarksRecordPositionAttributes';
import { model } from '../modelBuilder';
import ApplicationModel, { attr } from '../ApplicationModel';

interface BookmarksRecordPosition extends BookmarksRecordPositionAttributes {}

@model
class BookmarksRecordPosition extends ApplicationModel {
  // Start auto-generated
  static typename: 'BookmarksRecordPosition' = 'BookmarksRecordPosition';
  get typename(): 'BookmarksRecordPosition' {
    return 'BookmarksRecordPosition';
  }

  static bookmarkName = 'Bookmarks::RecordPosition';

  static inputType = 'RecordPositionAttributes!';

  static fields = {
    bookmarkId: attr({ writable: true, readable: false }),
    bookmarkType: attr({ writable: true, readable: true }),
    id: attr({ readable: true }),
    placeAfterId: attr({ writable: true, readable: false }),
    placeAfterType: attr({ writable: true, readable: false }),
    placeBeforeId: attr({ writable: true, readable: false }),
    placeBeforeType: attr({ writable: true, readable: false }),
    placement: attr({ writable: true, readable: false }),
    position: attr({ readable: true }),
    rank: attr({ writable: true, readable: false }),
    recordId: attr({ writable: true, readable: true }),
    recordType: attr({ writable: true, readable: true }),
    secondaryScope: attr({ readable: true }),
    secondaryScopeId: attr({ writable: true, readable: false }),
  };
  // End auto-generated
}

export default BookmarksRecordPosition;
